import React, {useEffect, useState} from 'react'
import {ManageAdminGrid} from './components/ManageAdminGrid'
import AddMemberModal from './components/modals/AddMemberModal'
import EditMemberModal from './components/modals/EditMemberModal'
import { getMember, getMembers } from '../../services/membersAdminService'
import { KTSVG } from '../../../_metronic/helpers'
import Pagination from '../components/Pagination'

export const ManageAdminPage: React.FC = () => {
  const limit = 5;
  const [membersData, setMembersData] = useState([])
  const [loading, setLoading] = useState<boolean>(false)
  const [memberInfo, setMemberInfo] = useState({})
  const [showInviteModal, setShowInviteModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [paginationData, setPaginationData] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    //getData()
    handlePageChange(1);
  }, [])

  const getData = (params:any={}) => {
    let isMounted = true
    const fetch = async () => {
      try {
        const data = await getMembers(params)
        if (isMounted) {
          setPaginationData(data);
          setMembersData(data.results);
        }
      } catch (err) {
        if (isMounted) {
          setError(err as Error)
        }
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }
    fetch()
    return () => {
      isMounted = false
    }
  }

  const handleAdd = () => {
    setShowInviteModal(false)
    handlePageChange(currentPage)
  }

  const handleEdit = async () => {
    setShowEditModal(false)
    handlePageChange(currentPage)
  }

  const onRowClick = async (id: any) => {
    const member2 = await getMember(id);
    setMemberInfo(member2)
    setShowEditModal(true)
  };

  const handlePageChange = async (page: number) => {
      const offset = (page - 1) * limit;
      await getData({ limit, offset });
      setCurrentPage(page);
  };

  const totalPages = paginationData
        ? Math.ceil(paginationData.count / limit)
        : 1;

  return (
    <div className='manage-member-page'>
      <div className='manage-member-page__content'>
        <div className="d-flex flex-row w-100 justify-content-between">
            <div className="tap-host-title">Nobilis Administrators</div>
            <div className="tap-add-experience-2-btn-main" onClick={()=>setShowInviteModal(true)}>
                <div className="tap-host-button-text tap-flex-center">
                    Add admin &nbsp;<KTSVG path='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' />
                </div>
            </div>
        </div>

        <div className='manage-member-page__table'>
          <ManageAdminGrid members={membersData} page={currentPage} limit={limit} loading={loading} onRowClick={onRowClick} />
        </div>

        
        <div className='manage-member-page__pagination'>
          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
      </div>

      {showInviteModal && <AddMemberModal
        isOpen={showInviteModal}
        onClose={() => handleAdd()}
      />}

      {showEditModal && <EditMemberModal
        isOpen={showEditModal}
        memberInfo={memberInfo}
        onClose={() => handleEdit()}
      />}
    </div>    
  )
}
